import {AuthSession, FetchAuthSessionOptions, IAuthService, RedirectSignInOptions, RegisterExternalUserParams, SignUpParams} from '../../services/auth/AuthService';
import {AuthResult, TokenValidation} from '../../../shared/types/auth';
import {User} from '../../../utils/typescript/interfaces';
import {getCurrentDemoPersona} from './fixtures';

// Fully local, no-auth identity for mock mode. The active persona is read from
// localStorage on each call so switching personas (DemoPanel) + reloading works
// without re-instantiating the service.
export class MockAuthService implements IAuthService {
    private get persona() { return getCurrentDemoPersona(); }

    private get token() {
        const u = this.persona.authUser;
        return {toString: () => 'mock-id-token', payload: {sub: u.sub, email: u.email}} as any;
    }

    async getCurrentAuthUser(): Promise<any> {
        return {username: this.persona.authUser.sub};
    }

    async getCurrentUser(): Promise<User | null> {
        return this.persona.authUser;
    }

    async fetchAuthSession(_options?: FetchAuthSessionOptions): Promise<AuthSession> {
        const u = this.persona.authUser;
        return {
            tokens: {idToken: this.token, accessToken: this.token},
            identityId: u.sub,
            userSub: u.sub,
        };
    }

    async signIn(): Promise<AuthResult> {
        return {user: this.persona.authUser, accessToken: 'mock-access-token', refreshToken: '', expiresIn: 3600};
    }

    async signOut(): Promise<void> {}

    async refreshToken(): Promise<string> {
        return 'mock-id-token';
    }

    async validateToken(): Promise<TokenValidation> {
        const u = this.persona.authUser;
        return {isValid: true, userId: u.sub, clientId: u['custom:clientId']};
    }

    async resetPassword(): Promise<void> {}

    async confirmResetPassword(): Promise<void> {}

    async deleteUser(): Promise<void> {}

    async updatePassword(): Promise<void> {}

    async updateUserAttributes(): Promise<void> {}

    async signUp(): Promise<{userId: string; nextStep: any}> {
        return {userId: this.persona.authUser.sub, nextStep: null};
    }

    async registerExternalUser(_params: RegisterExternalUserParams): Promise<void> {}

    async confirmSignUp(): Promise<void> {}

    async resendSignUpCode(): Promise<void> {}

    async signInWithRedirect(_provider?: string, _options?: RedirectSignInOptions): Promise<void> {}
}
